module.exports = __webpack_public_path__ + "static/media/error-404-image.a504cd82.png";